'use strict';

const Ajax = require('common/infra/ajax');

class API {
    create(projectID, commentID, reactionName) {
        const body = {
            reactionName: reactionName
        };
        return Ajax.POST(`/api/projects/${projectID}/comments/${commentID}/reactions`, body)
    }

    delete(projectID, commentID, reactionName) {
        return Ajax.DELETE(`/api/projects/${projectID}/comments/${commentID}/reactions/${reactionName}`)
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./communication/infra/api/comment-reaction.js